import { AUTH_CONFIG } from "../../authConfig";
import { CONFIG } from "../../config/index";
import { getPermissionKey } from "../../helper/permissions";
export const generalStore = [
    {
        title: "getMasterDbHeaderData",
        actionPrefix: "getMasterDbHeader",
        message: "Request Completed Successfully",
        requestData: {
            buildUrl: (payload) => `${CONFIG.BASE_URL}/core/org/get/masterDbData`,
        },
    },
    {
        title: "getMasterDbFilterData",
        actionPrefix: "getMasterDbFilter",
        message: "Request Completed Successfully",
        requestData: {
            buildUrl: (payload) => `${CONFIG.BASE_URL}/core/org/get/masterDbData`,
        },
    },
    {
        title: "getMasterDbDropdownData",
        actionPrefix: "getMasterDbDropdown",
        message: "Request Completed Successfully",
        requestData: {
            buildUrl: (payload) => `${CONFIG.BASE_URL}/core/org/get/masterDbData`,
        },
    },
    {
        title: "getDataExportModalData",
        actionPrefix: "getDataExportModal",
        message: "Request Completed Successfully",
        requestData: {
            buildUrl: (payload) => `${CONFIG.BASE_URL}/core/org/data/export/getAll`,
        },
    },
    {
        title: "cancelDataExportModalData",
        actionPrefix: "cancelDataExportModal",
        message: "Request Completed Successfully",
        requestData: {
            buildUrl: (payload) => `${CONFIG.BASE_URL}/download/cancel/export`,
        },
    },
    {
        title: "getNotificationModalData",
        actionPrefix: "getNotificationModal",
        message: "Request Completed Successfully",
        requestData: {
            buildUrl: (payload) => `${CONFIG.BASE_URL}/get/all/notifications`,
        },
    },
    {
        title: "getHeadersData",
        actionPrefix: "getHeaders",
        message: "Request Completed Successfully",
        requestData: {
            method: "GET",
            buildUrl: (payload) =>
                `${CONFIG.BASE_URL}/headerconfig/get/header?enterpriseName=${payload.enterpriseName}&attributeType=${payload.attributeType}&displayName=${payload.displayName}&orgId=`,
        },
        responseData: {
            successDataHandler: (response, payload) => {
                console.log("Resource Data1", response, payload);
                if (response?.data?.data) {
                    response.data.data["basedOn"] = payload?.["basedOn"];
                }
                return response?.data?.data;
            },
        },
    },
    {
        title: "getQuickFiltersData",
        actionPrefix: "getQuickFilters",
        message: "Request Completed Successfully",
        requestData: {
            buildUrl: (payload) => `${CONFIG.BASE_URL}/headerconfig/get/filter`,
        },
    },
    {
        title: "getDropdownData",
        actionPrefix: "getDropdown",
        message: "Request Completed Successfully",
        takeEvery: true,
        requestData: {
            method: "GET",
            buildUrl: (payload) =>
                `${CONFIG.BASE_URL}/core/dropdown/get?type=${payload?.type}`,
        },
    },
    {
        title: "downloadReportData",
        actionPrefix: "downloadReport",
        message: "Request Completed Successfully",
        requestData: {
            updatePayload: ({ ...payload }) => {
                delete payload.apiUrl;
                delete payload.summaryApiUrl;
                delete payload.baseUrl;
                if ("deleteKeysPayload" in payload) {
                    if (Object.keys(payload.deleteKeysPayload || {})?.length !== 0) {
                        Object.keys(payload.deleteKeysPayload || {})?.map((key) => {
                            if (!payload.deleteKeysPayload?.[key]?.includes(payload?.[key])) {
                                delete payload[key];
                            }
                        });
                        delete payload.deleteKeysPayload;
                    } else {
                        delete payload.deleteKeysPayload;
                    }
                }
                return payload;
            },
            isPayloadExistParams: true,
            buildUrl: (payload) =>
                `${payload?.baseUrl ? payload?.baseUrl : CONFIG.BASE_URL}${payload?.apiUrl
                    ? `${payload?.apiUrl}?fileType=XLS&module=${payload.module}&isAllData=${payload.isAllData}&isOnlyCurrentPage=${payload.isOnlyCurrentPage}`
                    : `/download/module/data?fileType=XLS&module=${payload.module}&isAllData=${payload.isAllData}&isOnlyCurrentPage=${payload.isOnlyCurrentPage}`
                }`,
        },
    },
    {
        title: "downloadDocumentsData",
        actionPrefix: "downloadDocuments",
        message: "Document Downloaded & Saved Successfully!",
        errorMessage: "Failed To Download the Required Document!",
        requestData: {
            buildUrl: (payload) => `${CONFIG.BASE_URL}/utility/document/download`,
        },
    },
    {
        title: "downloadDocumentsBarcodeData",
        actionPrefix: "downloadDocumentsBarcode",
        errorMessage: "Failed To Download the Required Document!",
        requestData: {
            buildUrl: (payload) => `${CONFIG.BASE_URL}/utility/document/download`,
        },
    },
    {
        title: "createEmailSchedulesData",
        actionPrefix: "createEmailSchedules",
        message: "Request Completed Successfully",
        requestData: {
            updatePayload: ({ ...payload }) => {
                delete payload.apiUrl;
                delete payload.summaryApiUrl;
                delete payload.baseUrl;
                return payload;
            },
            buildUrl: (payload) =>
                `${payload?.baseUrl ?? CONFIG.BASE_URL}${payload?.apiUrl ?? `${CONFIG.SYSTEM_CONFIG}/create/email/scheduler`
                }`,
        },
    },
    {
        title: "deleteEmailSchedulesData",
        actionPrefix: "deleteEmailSchedules",
        message: "Request Completed Successfully",
        requestData: {
            buildUrl: (payload) =>
                `${CONFIG.BASE_URL}/ars/plan/delete/email/scheduler`,
        },
    },
    {
        title: "emailReportData",
        actionPrefix: "emailReport",
        message: "Request Completed Successfully",
        requestData: {
            updatePayload: ({ ...payload }) => {
                delete payload.apiUrl;
                delete payload.summaryApiUrl;
                delete payload.baseUrl;
                return payload;
            },
            isPayloadExistParams: true,
            buildUrl: (payload) =>
                `${payload?.baseUrl ?? CONFIG.BASE_URL}${payload?.apiUrl ?? "/download/send/email/module/data"
                }?fileType=XLS&module=${payload.module}&isAllData=${payload.isAllData
                }&isOnlyCurrentPage=${payload.isOnlyCurrentPage}`,
        },
    },
    {
        title: "getImageTrackingData",
        actionPrefix: "getImageTracking",
        message: "Request Completed Successfully",
        requestData: {
            updatePayload: ({ ...payload }) => {
                payload.type == 2 &&
                    Object.keys(payload.filter).map((key) => {
                        if (payload.filter[key] === "") {
                            delete payload.filter[key];
                        }
                    });
                return payload;
            },
            buildUrl: (payload) => `${CONFIG.BASE_URL}${CONFIG.PO}/get/po/detail`,
        },
    },
    {
        title: "getRefreshReportData",
        actionPrefix: "getRefreshReport",
        message: "Request Completed Successfully",
        requestData: {
            buildUrl: (payload) => `${CONFIG.BASE_URL}/plan/settings/refresh/mview`,
        },
    },
    {
        title: "createHeadersData",
        actionPrefix: "createHeaders",
        message: "Headers Configuration Updated Successfully.",
        errorMessage: "Failed To Set Up Headers Configuration!",
        requestData: {
            buildUrl: (payload) => `${CONFIG.BASE_URL}/headerconfig/create`,
        },
        responseData: {
            successDataHandler: (response, payload) => {
                let resp = JSON.parse(JSON.stringify(response));
                if (resp?.data?.data) {
                    resp.data.data["basedOn"] = payload?.["basedOn"];
                    resp.data.data["displayName"] = payload?.["displayName"];
                    resp.data.data["Custom Headers"] = payload?.["customHeaders"];
                    resp.data.data["Default Headers"] = payload?.["defaultHeaders"];
                    resp.data.data["Fixed Headers"] = payload?.["fixedHeaders"];
                    resp.data.data["exportFilters"] = payload?.["exportFilter"];
                    resp.data.data["isDisplay"] = payload?.["isDisplay"];
                    resp.data.data["freezeColumn"] = payload?.["freezeColumn"];
                }
                console.log("Resource Data1", resp, payload);
                return resp?.data?.data;
            },
        },
    },
    {
        title: "createQuickFiltersData",
        actionPrefix: "createQuickFilters",
        message: "Request Completed Successfully",
        requestData: {
            buildUrl: (payload) => `${CONFIG.BASE_URL}/headerconfig/create/filter`,
        },
        responseData: {
            successDataHandler: (response, payload) => {
                let resp = JSON.parse(JSON.stringify(response));
                if (resp?.data?.data) {
                    resp.data.data["basedOn"] = payload?.["basedOn"];
                    resp.data.data["displayName"] = payload?.["displayName"];
                    resp.data.data["isDeleteFilter"] = payload?.["isDeleteFilter"];
                    resp.data.data["is_default"] = payload?.["is_default"];
                    resp.data.data["filterName"] = payload?.["filterName"];
                    resp.data.data["filterValue"] = payload?.["filterValue"];
                }
                // console.log("Resource Data1", resp, payload);
                return resp?.data?.data;
            },
        },
    },
    {
        title: "getBarcodeReportData",
        actionPrefix: "getBarcodeReport",
        message: "Request Completed Successfully",
        requestData: {
            buildUrl: (payload) => `${CONFIG.BASE_URL}/barcode/get/data`,
        },
    },
    {
        title: "getSearchFiltersData",
        actionPrefix: "getSearchFilters",
        message: "Request Completed Successfully",
        requestData: {
            buildUrl: (payload) =>
                `${CONFIG.BASE_URL}/plan/settings/search/arsGenericFilters`,
            extraHeader: getPermissionKey("common", "commonFunctionality", "view"),
        },
    },
    {
        title: "getEmailSchedulesData",
        actionPrefix: "getEmailSchedules",
        message: "Request Completed Successfully",
        requestData: {
            buildUrl: (payload) =>
                `${CONFIG.SM_BACKEND_BASE_URL}/admin/master/get/all/email/scheduler`,
        },
    },
    {
        title: "getAllAuditData",
        actionPrefix: "getAllAudit",
        message: "Request Completed Successfully",
        requestData: {
            buildUrl: (payload) => `${CONFIG.BASE_URL}/get/all/default/logs`,
        },
    },
    {
        title: "getAuditData",
        actionPrefix: "getAudit",
        message: "Request Completed Successfully",
        requestData: {
            buildUrl: (payload) => `${CONFIG.BASE_URL}/get/all/default/logs`,
        },
    },
    {
        title: "getAuditDetailData",
        actionPrefix: "getAuditDetail",
        errorMessage: "Failed to get the audit log details!",
        requestData: {
            buildUrl: (payload) => `${CONFIG.BASE_URL}/get/all/detailed/logs`,
        },
    },
    {
        title: "getTableComponentSummaryData",
        actionPrefix: "getTableComponentSummary",
        message: "Request Completed Successfully",
        requestData: {
            updatePayload: ({ ...payload }) => {
                delete payload.apiUrl;
                delete payload.summaryApiUrl;
                delete payload?.baseUrl;
                delete payload?.summaryApiBaseUrl;
                delete payload?.isChangeSummaryBaseUrl;
                return payload;
            },
            buildUrl: (payload) => {
                console.log(678678, payload);
                return `${payload?.isChangeSummaryBaseUrl &&
                    (payload.summaryApiBaseUrl || payload?.baseUrl)
                    ? payload.summaryApiBaseUrl || payload?.baseUrl
                    : CONFIG.BASE_URL
                    }${payload.summaryApiUrl}`;
            },
        },
    },
    {
        title: "getHeaderConfigExcelData",
        actionPrefix: "getHeaderConfigExcel",
        message: "Request Completed Successfully",
        requestData: {
            updatePayload: ({ ...payload }) => {
                delete payload.summaryApiUrl;
                return payload;
            },
            buildUrl: (payload) => `${CONFIG.BASE_URL}${payload.summaryApiUrl}`,
        },
    },
    {
        title: "getTableComponentListData",
        actionPrefix: "getTableComponentList",
        message: "Table Data Recieved Successfully.",
        errorMessage: "Unable To Get the Table Data!",
        requestData: {
            updatePayload: ({ ...payload }) => {
                delete payload.baseUrl;
                delete payload.apiUrl;
                delete payload.summaryApiUrl;
                delete payload.isChangeSummaryBaseUrl;
                if ("deleteKeysPayload" in payload) {
                    if (Object.keys(payload.deleteKeysPayload || {})?.length !== 0) {
                        Object.keys(payload.deleteKeysPayload || {})?.map((key) => {
                            if (!payload.deleteKeysPayload?.[key]?.includes(payload?.[key])) {
                                delete payload[key];
                            }
                        });
                        delete payload.deleteKeysPayload;
                    } else {
                        delete payload.deleteKeysPayload;
                    }
                }
                if ("updatePayload" in payload) {
                    if (
                        payload?.[payload?.updatePayload?.key] ==
                        payload?.updatePayload?.fromVal
                    ) {
                        payload[payload?.updatePayload?.key] =
                            payload?.updatePayload?.value;
                    }
                    delete payload.updatePayload;
                }
                return payload;
            },
            buildUrl: (payload) =>
                `${payload.baseUrl ? payload?.baseUrl : CONFIG.BASE_URL}${payload.apiUrl
                }`,
        },
    },
    {
        title: "getGeneralListData",
        actionPrefix: "getGeneralList",
        message: "Data Fetched Successfully.",
        errorMessage: "Unable To fetch the data!",
        requestData: {
            method: "GET",
            buildUrl: (payload) =>
                `${payload.baseUrl ? payload?.baseUrl : CONFIG.BASE_URL}${payload.apiUrl
                }`,
        },
    },
    {
        title: "getTableComponentSecondListData",
        actionPrefix: "getTableComponentSecondList",
        message: "Request Completed Successfully",
        takeEvery: true,
        requestData: {
            updatePayload: ({ ...payload }) => {
                console.log(678678, payload);
                delete payload.apiUrl;
                delete payload.baseUrl;
                delete payload?.uniqueExpandId;
                return payload;
            },
            buildUrl: (payload) =>
                `${payload.baseUrl ? payload?.baseUrl : CONFIG.BASE_URL}${payload.apiUrl
                }`,
        },
        responseData: {
            successDataHandler: (response, payload) => {
                let resp = JSON.parse(JSON.stringify(response));
                if (resp?.data?.data && payload?.["uniqueExpandId"]) {
                    resp.data.data["uniqueExpandId"] = payload?.uniqueExpandId;
                }
                return resp?.data?.data;
            },
            errorDataHandler: (response, payload) => {
                let resp = JSON.parse(JSON.stringify(response));
                if (resp?.data?.data && payload?.["uniqueExpandId"]) {
                    resp.data.data["uniqueExpandId"] = payload?.uniqueExpandId;
                }
                return resp?.data?.data;
            },
        },
    },
    {
        title: "getTableComponentThirdListData",
        actionPrefix: "getTableComponentThirdList",
        message: "Request Completed Successfully",
        takeEvery: true,
        requestData: {
            updatePayload: ({ ...payload }) => {
                delete payload.apiUrl;
                delete payload.baseUrl;
                delete payload?.uniqueExpandId;
                return payload;
            },
            buildUrl: (payload) =>
                `${payload.baseUrl ? payload?.baseUrl : CONFIG.BASE_URL}${payload.apiUrl
                }`,
        },
        responseData: {
            successDataHandler: (response, payload) => {
                let resp = JSON.parse(JSON.stringify(response));
                if (resp?.data && payload?.["uniqueExpandId"]) {
                    resp.data.data["uniqueExpandId"] = payload?.uniqueExpandId;
                }
                return resp?.data?.data;
            },
            errorDataHandler: (response, payload) => {
                let resp = JSON.parse(JSON.stringify(response));
                if (resp?.data && payload?.["uniqueExpandId"]) {
                    resp.data.data["uniqueExpandId"] = payload?.uniqueExpandId;
                }
                return resp?.data?.data;
            },
        },
    },
    {
        title: "getTableComponentFourthListData",
        actionPrefix: "getTableComponentFourthList",
        message: "Request Completed Successfully",
        requestData: {
            updatePayload: ({ ...payload }) => {
                delete payload.apiUrl;
                delete payload.baseUrl;
                return payload;
            },
            buildUrl: (payload) =>
                `${payload.baseUrl ? payload?.baseUrl : CONFIG.BASE_URL}${payload.apiUrl
                }`,
        },
    },
    {
        title: "getTableComponentFifthListData",
        actionPrefix: "getTableComponentFifthList",
        message: "Request Completed Successfully",
        requestData: {
            updatePayload: ({ ...payload }) => {
                delete payload.apiUrl;
                delete payload.baseUrl;
                delete payload.uniqueKey;
                return payload;
            },
            buildUrl: (payload) =>
                `${payload.baseUrl ? payload?.baseUrl : CONFIG.BASE_URL}${payload.apiUrl
                }`,
        },
    },
    {
        title: "getTableComponentSixthListData",
        actionPrefix: "getTableComponentSixthList",
        message: "Request Completed Successfully",
        requestData: {
            updatePayload: ({ ...payload }) => {
                delete payload.apiUrl;
                delete payload.baseUrl;
                return payload;
            },
            buildUrl: (payload) =>
                `${payload.baseUrl ? payload?.baseUrl : CONFIG.BASE_URL}${payload.apiUrl
                }`,
        },
    },
    {
        title: "getTableComponentSeventhListData",
        actionPrefix: "getTableComponentSeventhList",
        message: "Request Completed Successfully",
        requestData: {
            updatePayload: ({ ...payload }) => {
                delete payload.apiUrl;
                delete payload.baseUrl;
                return payload;
            },
            buildUrl: (payload) =>
                `${payload.baseUrl ? payload?.baseUrl : CONFIG.BASE_URL}${payload.apiUrl
                }`,
        },
    },
    {
        title: "getGenericExcelTemplateData",
        actionPrefix: "getGenericExcelTemplate",
        message: "Request Completed Successfully",
        requestData: {
            method: "GET",
            // buildUrl: (payload) => `${CONFIG.BASE_URL}/upload/get/all/templates` // old api url
            buildUrl: (payload) => `${CONFIG.SM_BACKEND_BASE_URL}/mdm/config/get/excel/templates` // new api url
        }
    },
    {
        title: "validateGenericExcelSheetData",
        actionPrefix: "validateGenericExcelSheet",
        message: "Request Completed Successfully",
        requestData: {
            buildUrl: (payload) =>
                `${CONFIG.BASE_URL}/system/config/submit/excel/data`,
        },
    },
    {
        title: "getSupplymintTraningGuidesData",
        actionPrefix: "getSupplymintTraningGuides",
        message: "Request Completed Successfully",
        requestData: {
            buildUrl: (payload) =>
                `${CONFIG.BASE_URL}/core/org/get/all/training/guide`,
        },
    },
    {
        title: "commentNotificationData",
        actionPrefix: "commentNotification",
        message: "Request Completed Successfully",
        requestData: {
            buildUrl: (payload) =>
                `${CONFIG.BASE_URL}${CONFIG.VENDORPROTAL}/comqc/comments/notification`,
        },
    },
    {
        title: "qcAddCommentData",
        actionPrefix: "qcAddComment",
        message: "Request Completed Successfully",
        requestData: {
            buildUrl: (payload) =>
                `${CONFIG.BASE_URL}${CONFIG.VENDORPROTAL}/comqc/add/comqcinvoice`,
        },
    },
    {
        title: "getAllCommentData",
        actionPrefix: "getAllComment",
        message: "Request Completed Successfully",
        requestData: {
            buildUrl: (payload) =>
                `${CONFIG.BASE_URL}${CONFIG.VENDORPROTAL}/comqc/find/all/comqcinvoice`,
        },
    },
    {
        title: "getUserEmailsData",
        actionPrefix: "getUserEmails",
        message: "Request Completed Successfully",
        requestData: {
            buildUrl: (payload) => `${CONFIG.BASE_URL}${CONFIG.CORE_USER}/find/info`,
        },
    },
    {
        title: "deleteUploadsCommentsData",
        actionPrefix: "deleteUploadsComments",
        message: "Request Completed Successfully",
        requestData: {
            buildUrl: (payload) =>
                `${CONFIG.BASE_URL}${CONFIG.VENDORPROTAL}/comqc/delete/uploads`,
        },
    },
    {
        title: "emailTranscriptData",
        actionPrefix: "emailTranscript",
        message: "Request Completed Successfully",
        requestData: {
            buildUrl: (payload) =>
                `${CONFIG.BASE_URL}/notification/email/send/transcript`,
        },
    },
    {
        title: "removeMultipleFileUploadData",
        actionPrefix: "removeMultipleFileUpload",
        message: "Request Completed Successfully",
        requestData: {
            buildUrl: (payload) =>
                `${CONFIG.BASE_URL}/admin/custom/remove/multiple/file/upload`,
        },
    },
    {
        title: "getProcExcelTemplateData",
        actionPrefix: "getProcExcelTemplate",
        requestData: {
            buildUrl: (payload) =>
                `${CONFIG.BASE_URL}/admin/po/excel/upload/drop/down/data`,
        },
    },
    {
        title: "validateProcExcelData",
        actionPrefix: "validateProcExcel",
        message: "Excel Data Validated Successfully",
        errorMessage: "Failed To Validate Excel Data!",
        requestData: {
            updatePayload: ({ ...payload }) => {
                delete payload.apiUrl;
                return payload;
            },
            buildUrl: (payload) =>
                `${CONFIG.BASE_URL}${payload?.apiUrl ?? "/admin/po/excel/data/validation"
                }`,
        },
    },
    {
        title: "submitProcExcelData",
        actionPrefix: "submitProcExcel",
        message: "Digiproc Excel Data Submitted Successfully",
        errorMessage: "Failed To Submit Excel Data!",
        requestData: {
            buildUrl: (payload) => `${CONFIG.BASE_URL}/admin/po/excel/submit/data`,
        },
    },
    {
        title: "getUploadedUtilityDocumentData",
        actionPrefix: "getUploadedUtilityDocument",
        errorMessage: "Failed To fetch the uploaded files!",
        requestData: {
            buildUrl: (payload) =>
                `${CONFIG.BASE_URL}/utility/document/download/filepath`,
        },
    },
    {
        title: "getAnnouncementData",
        actionPrefix: "getAnnouncement",
        requestData: {
            token: false,
            buildUrl: (payload) => `${AUTH_CONFIG.BASE_URL}/get/details`,
            extraHeader: {
                "access-control-request-headers": "content-type",
                "access-control-request-method": "POST",
                "Page-Link": undefined,
            },
        },
    },
    {
        title: "getDocumentDownloadFilepathData",
        actionPrefix: "getDocumentDownloadFilepath",
        errorMessage: "Failed To Load Data!",
        requestData: {
            buildUrl: (payload) =>
                `${CONFIG.BASE_URL}/utility/document/download/filepath`,
        },
    },
    {
        title: "utilityDocumentDownloadData",
        actionPrefix: "utilityDocumentDownload",
        message: "Document Download Successfully",
        errorMessage: "Failed To Load Data!",
        requestData: {
            buildUrl: (payload) => `${CONFIG.BASE_URL}/utility/document/download`,
        },
    },
    // Api : To get the generic dropdown data for all modules.
    {
        title: "getMasterDbDocumentDropdownData",
        actionPrefix: "getMasterDbDocumentDropdown",
        errorMessage: "Failed To Get the List of Documents Dropdown!",
        requestData: {
            method: "GET",
            buildUrl: (payload) =>
                `${CONFIG.BASE_URL}/system/config/list/download/document?displayName=`,
        },
    },
    // Api : To get the data of the specific document dropdown according to a display name.
    {
        title: "getDocumentDropdownData",
        actionPrefix: "getDocumentDropdown",
        errorMessage: "Failed To Get the List of Documents Dropdown!",
        requestData: {
            method: "GET",
            buildUrl: (payload) =>
                `${CONFIG.BASE_URL}/system/config/list/download/document?displayName=${payload.displayName}`,
        },
    },
    // Api:  to get the taxn and purchase term dicount  information throughout the supplymint
    {
        title: "getPurchaseTermOrderInfoData",
        actionPrefix: "getPurchaseTermOrderInfo",
        errorMessage: "Failed To Get the purchase information for document!",
        requestData: {
            buildUrl: (payload) => `${CONFIG.BASE_URL}/admin/po/get/term/info`,
        },
    },
    {
        title: "userSessionCreateData",
        actionPrefix: "userSessionCreate",
        errorMessage: "Failed To Create Session!",
        requestData: {
            buildUrl: (payload) => `${AUTH_CONFIG.BASE_URL}/session/update`,
            token: false,
            extraHeader: {
                "Page-Link": undefined,
            },
        },
    },
    {
        title: "getBootSettingsForApplicationData",
        actionPrefix: "getBootSettingsForApplication",
        errorMessage: "Failed to get the boot setting for the application.",
        requestData: {
            token: false,
            buildUrl: (payload) => `${CONFIG.BASE_URL}/open/key/get/profile/config`,
        },
    },
    {
        title: "getUserDataMappingData",
        actionPrefix: "getUserDataMapping",
        errorMessage: "Failed To Create Session!",
        requestData: {
            method: "GET",
            buildUrl: (payload) =>
                `${CONFIG.BASE_URL}/system/config/get/user/data/mapping`,
        },
    },
    {
        title: "getCommentsDocumentsListData",
        actionPrefix: "getCommentsDocumentsList",
        errorMessage: "Failed to get the documents list for comments.",
        requestData: {
            buildUrl: (payload) =>
                `${CONFIG.NOTIFICATION_ROUTE_PROD}/comment/getAllCommentsDocuments`,
        },
    },
    {
        title: "downloadCommentTranscriptData",
        actionPrefix: "downloadCommentTranscript",
        errorMessage: "Failed to download the comments transcript.",
        requestData: {
            buildUrl: (payload) =>
                `${CONFIG.NOTIFICATION_ROUTE_PROD}/comment/downloadTranscript`,
        },
    },
    {
        title: "getItemFilterConfigurationData",
        actionPrefix: "getItemFilterConfiguration",
        errorMessage: "Failed to get the list of item filters.",
        requestData: {
            method: "GET",
            buildUrl: (payload) =>
                `${CONFIG.SM_BACKEND_BASE_URL}/mdm/config/get/key?key=ITEM_FILTER_CONFIG_TEMP`,
        },
    },
    {
        title: "getItemFilterForDisplayNameData",
        actionPrefix: "getItemFilterForDisplayName",
        errorMessage: "Failed to get the list of item filters",
        requestData: {
            method: "GET",
            buildUrl: (payload) =>
                `${CONFIG.SM_BACKEND_BASE_URL}/mdm/config/get/key?key=ITEM_FILTER_CONFIG_TEMP`,
        },
    },
    {
        title: "getTabsConfigurationData",
        actionPrefix: "getTabsConfiguration",
        errorMessage: "Failed to get the tabs list for the pages.",
        requestData: {
            buildUrl: (payload) =>
                `${CONFIG.SM_BACKEND_BASE_URL}/admin/module/tabs/get/all`,
        },
    },
    {
        title: "getTabsConfigurationForModuleCodeData",
        actionPrefix: "getTabsConfigurationForModuleCode",
        errorMessage: "Failed to get the tabs list for the page",
        requestData: {
            buildUrl: (payload) =>
                `${CONFIG.SM_BACKEND_BASE_URL}/admin/module/tabs/get/all`,
        },
    },
    {
        title: "getCommentInformationData",
        actionPrefix: "getCommentInformation",
        errorMessage: "Failed to get the comment information.",
        requestData: {
            buildUrl: (payload) =>
                `${CONFIG.NOTIFICATION_ROUTE_PROD}/comment/getCommentsInformation`,
        },
    },
    {
        title: "getPurchaseOtbData",
        actionPrefix: "getPurchaseOtb",
        message: "Table Data Recieved Successfully.",
        errorMessage: "Unable To Get the Table Data!",
        requestData: {
            updatePayload: ({ ...payload }) => {
                delete payload.baseUrl;
                delete payload.apiUrl;
                delete payload.summaryApiUrl;
                return payload;
            },
            buildUrl: (payload) =>
                `${payload.baseUrl ? payload?.baseUrl : CONFIG.BASE_URL}${payload.apiUrl
                }`,
        },
    },
    {
        title: "genericCreateData",
        actionPrefix: "genericCreate",
        message: "Create operation completed successfully!",
        errorMessage: "Unable To compelete the create operation!",
        requestData: {
            updatePayload: ({ ...payload }) => {
                delete payload.baseUrl;
                delete payload.apiUrl;
                delete payload.summaryApiUrl;
                return payload;
            },
            buildUrl: (payload) =>
                `${payload.baseUrl ? payload?.baseUrl : CONFIG.BASE_URL}${payload.apiUrl
                }`,
        },
    },
    {
        title: "genericUpdateData",
        actionPrefix: "genericUpdate",
        message: "Update operation completed successfully!",
        errorMessage: "Unable To compelete the update operation!",
        requestData: {
            updatePayload: ({ ...payload }) => {
                delete payload.baseUrl;
                delete payload.apiUrl;
                delete payload.summaryApiUrl;
                return payload;
            },
            buildUrl: (payload) =>
                `${payload.baseUrl ? payload?.baseUrl : CONFIG.BASE_URL}${payload.apiUrl
                }`,
        },
    },
    {
        title: "getCopySearchFiltersData",
        actionPrefix: "getCopySearchFilters",
        message: "Request Completed Successfully",
        requestData: {
            buildUrl: (payload) =>
                `${CONFIG.BASE_URL}/plan/settings/search/arsGenericFilters`,
            extraHeader: getPermissionKey("common", "commonFunctionality", "view"),
        },
    },
    // Api : To get the data for the document viewer data
    {
        title: "getDocumentViewerData",
        actionPrefix: "getDocumentViewer",
        message: "Document Data Received Successfully.",
        errorMessage: "Unable To Get the Document Data!",
        requestData: {
            updatePayload: ({ ...payload }) => {
                delete payload.baseUrl;
                delete payload.apiUrl;
                delete payload.summaryApiUrl;
                return payload;
            },
            buildUrl: (payload) =>
                `${payload.baseUrl ? payload?.baseUrl : CONFIG.SM_BACKEND_BASE_URL}${payload.apiUrl
                }`,
        },
    },
    // Api : To get the second level data for the document viewer data
    {
        title: "getDocumentViewerSecondLevelData",
        actionPrefix: "getDocumentViewerSecondLevel",
        message: "Document Data Received Successfully.",
        errorMessage: "Unable To Get the Document Data!",
        requestData: {
            updatePayload: ({ ...payload }) => {
                delete payload.baseUrl;
                delete payload.apiUrl;
                delete payload.summaryApiUrl;
                return payload;
            },
            buildUrl: (payload) =>
                `${payload.baseUrl ? payload?.baseUrl : CONFIG.SM_BACKEND_BASE_URL}${payload.apiUrl
                }`,
        },
    },
    // Api: To get the third level data for the document viewer data
    {
        title: "getDocumentViewerThirdLevelData",
        actionPrefix: "getDocumentViewerThirdLevel",
        message: "Document Data Received Successfully.",
        errorMessage: "Unable To Get the Document Data!",
        takeEvery: true,
        requestData: {
            updatePayload: ({ ...payload }) => {
                delete payload.baseUrl;
                delete payload.apiUrl;
                delete payload?.uniqueExpandId;
                return payload;
            },
            buildUrl: (payload) =>
                `${payload.baseUrl ? payload?.baseUrl : CONFIG.BASE_URL}${payload.apiUrl
                }`,
        },
        responseData: {
            successDataHandler: (response, payload) => {
                let resp = JSON.parse(JSON.stringify(response));
                if (resp?.data && payload?.["uniqueExpandId"]) {
                    resp.data.data["uniqueExpandId"] = payload?.uniqueExpandId;
                }
                return resp?.data?.data;
            },
            errorDataHandler: (response, payload) => {
                let resp = JSON.parse(JSON.stringify(response));
                if (resp?.data && payload?.["uniqueExpandId"]) {
                    resp.data.data["uniqueExpandId"] = payload?.uniqueExpandId;
                }
                return resp?.data?.data;
            },
        },
    },
    {
        title: "getGlobalSearchOrdersData",
        actionPrefix: "getGlobalSearchOrders",
        message: "Request Completed Successfully",
        requestData: {
            buildUrl: (payload) =>
                `${CONFIG.SM_BACKEND_BASE_URL}/purchase/order/get/all/purchase/orders`,
            extraHeader: getPermissionKey("common", "commonFunctionality", "view"),
        },
    },
    {
        title: "getSiteFilterWhData",
        actionPrefix: "getSiteFilterWh",
        message: "Request Completed Successfully",
        requestData: {
            buildUrl: (payload) =>
                `${CONFIG.SM_BACKEND_BASE_URL}/ars/rule/engine/get/all/site/filter`,
        },
    },
    {
        title: "getGrievanceData",
        actionPrefix: "getGrievance",
        message: "Grievance Retrived Successfully",
        requestData: {
            buildUrl: (payload) => `${CONFIG.NOTIFICATION_ROUTE_PROD}/product/grievance`,
        },
    },
    {
        title: "createGrievanceData",
        actionPrefix: "createGrievance",
        message: "Grievance Created Successfully",
        requestData: {
            buildUrl: (payload) => `${CONFIG.NOTIFICATION_ROUTE_PROD}/product/grievance`,
        },
    },
    {
        title: "updateGrievanceData",
        actionPrefix: "updateGrievance",
        message: "Grievance Updated Successfully",
        requestData: {
            buildUrl: (payload) => `${CONFIG.NOTIFICATION_ROUTE_PROD}/product/grievance/update`,
        },
    },
    {
        title: "deleteGrievanceData",
        actionPrefix: "deleteGrievance",
        message: "Grievance Deleted Successfully",
        requestData: {
            buildUrl: (payload) => `${CONFIG.NOTIFICATION_ROUTE_PROD}/product/grievance/delete`,
        },
    },
    {
        title: "grievanceSummaryData",
        actionPrefix: "grievanceSummary",
        message: "Grievance Summary Retrived Successfully",
        requestData: {
            buildUrl: (payload) => `${CONFIG.NOTIFICATION_ROUTE_PROD}/product/griveance/summary`,
        },
    },
    {
        title: "uploadGriveanceAttachmentData",
        actionPrefix: "uploadGriveanceAttachment",
        message: "Image/File uploaded successfully!",
        errorMessage: `Failed to upload Image/File!`,
        requestData: {
            buildUrl: (payload) => `${CONFIG.NOTIFICATION_ROUTE_PROD}/fileUpload/new`,
            extraHeader: {
                "Content-Type": "multipart/form-data",
            },
        },
        responseData: {
            successDataHandler: (response, payload) => {
                let resp = JSON.parse(JSON.stringify(response));
                return resp?.data;
            },
        },
    },
    {
        title: "getGrievanceConfigData",
        actionPrefix: "getGrievanceConfig",
        message: "Grievance Config Retrived Successfully",
        requestData: {
            buildUrl: (payload) =>
                `${CONFIG.SM_BACKEND_BASE_URL}/mdm/config/get/key?key=GREVIENCE_CONFIG`,
        },
    },
    {
        title: "createGrievanceConfigData",
        actionPrefix: "createGrievanceConfig",
        message: "Grievance Config Created Successfully",
        requestData: {
            buildUrl: (payload) =>
                `${CONFIG.BASE_URL}/system/config/update/configuration`,
        },
    },
    {
        title: "updateGrievanceConfigData",
        actionPrefix: "updateGrievanceConfig",
        message: "Grievance Config Updated Successfully",
        requestData: {
            buildUrl: (payload) =>
                `${CONFIG.BASE_URL}/system/config/update/configuration`,
        },
    },
    {
        title: "getVendorProfileData",
        actionPrefix: "getVendorProfile",
        message: "Vendor Profile Retrieved Successfully",
        requestData: {
            buildUrl: (payload) => `${CONFIG.SM_BACKEND_BASE_URL}/purchase/dashboard/vendor/profile`,
        }
    },
    {
        title: "getGrievanceDashboardSummaryData",
        actionPrefix: "getGrievanceDashboardSummary",
        message: "Grievance Dashboard Summary Retrived Successfully",
        requestData: {
            buildUrl: (payload) =>
                `${CONFIG.NOTIFICATION_ROUTE_PROD}/product/grievance/dashboard/summary`,
        },
    },
    {
        title: "getGrievanceDashboardChartData",
        actionPrefix: "getGrievanceDashboardChart",
        message: "Grievance Dashboard Chart Data Retrived Successfully",
        requestData: {
            buildUrl: (payload) =>
                `${CONFIG.NOTIFICATION_ROUTE_PROD}/product/grievance/dashboard/overview`,
        },
    },
    {
        title: "getGrievanceDashboardCategoryData",
        actionPrefix: "getGrievanceDashboardCategory",
        message: "Grievance Dashboard Category Data Retrived Successfully",
        requestData: {
            buildUrl: (payload) =>
                `${CONFIG.NOTIFICATION_ROUTE_PROD}/product/grievance/dashboard/categories`,
        },
    },
    {
        title: "getPortalDocPrevData",
        actionPrefix: "getPortalDocPrev",
        message: "Request Completed Successfully",
        takeEvery: true,
        requestData: {
            updatePayload: ({ ...payload }) => {
                delete payload.apiUrl;
                delete payload.baseUrl;
                delete payload?.uniqueExpandId;
                return payload;
            },
            buildUrl: (payload) =>
                `${payload.baseUrl ? payload?.baseUrl : CONFIG.BASE_URL}${payload.apiUrl
                }`,
        },
        responseData: {
            responseHandler: (response, payload) => {
                if(response?.status == 200){
                    return {success: true}
                }   
                else return {failure: true}
            },
            successDataHandler: (response, payload) => {
                return {data: response?.data};
            },
        },
    },
    {
        title: "getDocumentDetailsData",
        actionPrefix: "getDocumentDetails",
        message: "Request Completed Successfully",
        takeEvery: true,
        requestData: {
            updatePayload: ({ ...payload }) => {
                delete payload.apiUrl;
                return payload;
            },
            buildUrl: (payload) => `${CONFIG.NOTIFICATION_ROUTE_PROD}/url/resolve`,
        },
        responseData: {
            responseHandler: (response, payload) => {
                if(response?.status == 200){
                    return {success: true}
                }   
                else return {failure: true}
            },
            successDataHandler: (response, payload) => {
                return response?.data
            },
        },
    },
];
